module.exports = __webpack_public_path__ + "img/table-gjj.e304acb7.png";